import React, { useContext, useEffect } from "react";
import { Helmet } from "react-helmet";

import { logAnalyticsEvent } from "../firebase/firebaseConfig";


import { UserContext } from "../context/UserContext";
import { EnvContext } from "../context/EnvContext";
import NewsletterForm from "../screens/app/NewsletterForm";
import Footer from "./Footer";

const defaultTitle = 'Fullproof - Curated plant products for every vibe'

const PageLayout = ({ analyticsTitle, analyticsView, description, children, imageUrl, showNewsletterModal, title = defaultTitle, url }) => {
  const environment = useContext(EnvContext);
  const { loading: userLoading } = useContext(UserContext); // ADD recentlyViewedProducts

  // reload page rubber banding
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY < -200) {
        // User pulled down (rubber banding)
        window.location.reload(); // Reload the page
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);


  // analytics
  useEffect(() => {
    logAnalyticsEvent(`${analyticsView}_view`, {
      page_title: environment === "staging" ? `STAGING - ${analyticsTitle} Page` : `${analyticsTitle} Page`,
      page_location: window.location.href,
      page_path: window.location.pathname,
      environment: environment,
    });
  }, [environment, analyticsTitle, analyticsView]);

  // Show loading screen until user and age gate checks are complete
  if (userLoading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <>
      <Helmet>
        <title>{environment && environment !== "production" ? `${environment.toUpperCase()} - ` : ""}{title}</title>
        <meta property="og:title" content={title} />
        <meta
          property="og:description"
          content={description || "The specialty goods superstore — incredible quality, curated selection, and fast delivery all at unbeatable prices. Satisfaction guaranteed or your money back."}
        />
        <meta property="og:image" content={imageUrl || ''} />
        <meta property="og:url" content={url || `https://getfullproof.com`} />
        <meta property="og:type" content="product" />
      </Helmet>


      {showNewsletterModal && <NewsletterForm />}
      <main>{children}</main>

      <Footer />
    </>
  );
}


export default PageLayout;
